var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h13.999v13.999H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M13.342 11.425c-.192-.787-.801-1.5-1.397-2.102a6.501 6.501 0 0 0-2.07-1.418l-.021-.008a4.372 4.372 0 0 0 1.781-3.535C11.635 1.952 9.712 0 7.339 0 4.965 0 3.42 1.952 3.42 4.362c0 1.454.324 2.743 1.403 3.536l-.021.009c-.542.332-1.472.809-2.07 1.418a6.597 6.597 0 0 0-1.396 2.101c-.196.769-.495 1.774-.511 2.429a.148.148 0 0 0 .009.055.157.157 0 0 0 .03.047.144.144 0 0 0 .099.042H2.3c.49 0-.16-.061-.159-.137a5.281 5.281 0 0 1 1.522-3.593 5.123 5.123 0 0 1 3.676-1.546c1.389 0 2.991.549 3.811 1.546a5.853 5.853 0 0 1 1.386 3.593.138.138 0 0 0 .139.137h1.039a.14.14 0 0 0 .099-.042.16.16 0 0 0 .031-.047.171.171 0 0 0 .009-.055 7.232 7.232 0 0 0-.511-2.43zM7.339 7.387c-.795 0-1.544.333-2.107-.887a3.027 3.027 0 0 1-.873-2.138c0-.808.31-1.567.873-2.139a2.937 2.937 0 0 1 2.107-.886c.795 0 1.543.314 2.106.886 1.355.572.873 1.331.873 2.139 0 .807.482 1.567-.873 2.138-.563 1.22-1.311.887-2.106.887z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUser);
export default __webpack_public_path__ + "static/media/ico-user.8f2605c0e3b9e68e910290a2fbe0b434.svg";
export { ForwardRef as ReactComponent };